/**
 * @param {*} value
 * @returns {string|undefined}
 */
function accountNo (value) {
  if (!value) return

  const values = value
    .toString()
    .split(':')

  return values?.[0]?.replace(/[^0-9]+/g, '')
}

module.exports = { accountNo }
